import * as React from 'react';
import { Box, TextField, Typography, Alert, IconButton, Modal, Snackbar, Table, TableBody, TableCell, TableHead, TableRow, Card, CardContent, Tooltip, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Grid, Paper, TableContainer, Chip, TableSortLabel, TablePagination, MenuItem, Link, FormControl, InputLabel, Select, Button } from '@mui/material';
import Menu from '@mui/material/Menu';
import { GridRowId } from '@mui/x-data-grid';
import { Cached, Visibility, Refresh, Close, SyncAlt, SimCardDownload, Download, Delete, ForwardToInbox, FilterAlt, Search, Fullscreen, FlipCameraAndroid, Replay } from '@mui/icons-material';
import { bucketName, handleDownload, getStatusColor, baseUrl1, baseUrl, GridUrl, decodeJwt, UserRole, newstatusValueArray, statusValueFilterArray, getStatusColorActivity, JobInfoStatusEnum } from '../Pages/ApiCommonService';
import { fetchJob, viewJobActivityDetail, viewErrorForSelectedActivityName, retriggerTheFailedActivityStatusAgain, viewUploadedFileForDownload, generateURLForDownloadInputFiles, viewUploadedFileRemarks, DeleteJob, getAdminAccessforUser, DispatchJobId, UpdateJobStatus, tranferJob, triggerTheJobIdToCreateAgain, getFilesFromS3OutputPath } from '../ApiSevices/JobListingApis';
import { GridTable } from '../Sidebar/SidebarStyles';
import { createJobidForAfterFileUpload } from '../ApiSevices/FileUploadApis';
import { expTokenProcessAndGenerate } from '../ApiSevices/AuthApis';
import axios from 'axios';
import { getbroker } from '../ApiSevices/UserMasterApis';
import { Location } from 'react-router-dom';
import { SelectChangeEvent } from '@mui/material';
import { getJobinfostatus } from '../ApiSevices/ReportApis';


type Order = 'asc' | 'desc';
interface JobFileInfo {
    id: number;
    FileName: string;
    FileType: string;
    FileForId: any;
    Status: any;
    Checklist: any;
    ToFileName: string;
    FileSize: string;
    IsCorrupted: boolean;
    IsConverted: boolean;
    IsScanned: boolean;
    IsMerged: boolean;
    IsPublished: boolean;
    JobId: string;
    CreatedOn: string;
    PublishedFilePath: any
}
interface TableProps {
    displaysidebar: boolean;
    location: Location;
}
interface Filters {
    brokerName: string;
}
interface HeadCell {
    id: keyof Data;
    label: string;
    disableSort?: boolean;
}
interface Data {
    JobId: string;
    JobTypeId: any;
    IsAutoDispatchJob: any;
    ClientName: string;
    MacroFile: string;
    IsActive: boolean;
    CreatedOn: string;
    UploadedBy: string;
    DispatchedOn: string;
    TAT: any;
    Status: any;
    Checklist: any;
    Actions: string;
    Dispatch: string;
    UploadDiscrepancy: string;
    Remarks: string;
    UpdateStatus: any;
}
interface JobStatus {
    Id: number;
    Name: string;
    IsActive: boolean;
}
interface Row {
    DispatchedOn: string;
    MatchScore: string;
    JobTypeId: any;
    IsAutoDispatchJob: any;
    LobCode: string;
    CreatedOn: any;
    UploadedBy: string;
    UpdatedOn: any;
    Id: string;
    ClientName: string;
    JobId: string;
    JobOwner: string;
    MacroFile: string;
    Status: any;
    Checklist: any;
    IsActive: boolean;
    document?: File | null;
    documentName?: string;
    CreatedBy?: any;
    TAT?: any;
    Actions?: string;
    Dispatch?: string;
    UploadDiscrepancy?: string;
    Remarks?: string;
    UpdateStatus?: any;
    StpMatched: any;
}

interface State {
    rows: Row[];
    order: Order;
    orderBy: keyof Data;
    page: number;
    rowsPerPage: number;
    isDrawerOpen: boolean;
    selectedRow: Row | null;
    isEditing: boolean;
    selectedRowIds: GridRowId[];
    snackbarOpen: boolean;
    snackbarMessage: any;
    snackbarSeverity: any;
    loading: boolean;
    activities: any[];
    errorDetailsArray: any[];
    fileInfo: JobFileInfo[];
    Remarksinfo: any;
    getJobId: any;
    getChecklistName: any;
    getCSRProKey: any;
    getPolicyKey: any;
    getFormsKey: any;
    getExclusionKey: any;
    isActivityDrawerOpen: boolean;
    isFileModelOpen: boolean;
    isErrorCardOpen: boolean;
    selectedErrorMessage: string;
    searchTerm: string;
    searchQuery: string;
    isDialogOpen: boolean;
    isDeleteDialogOpen: boolean;
    isReProcessDialogOpen: boolean;
    reprocessBrokerId: any;
    isUpdateDialogOpen: boolean;
    isReprocessFlow: boolean;
    isCreateActivityDialogOpen: boolean,
    selectedJobId: any;
    selectedJobIdforModel: null;
    selectedInstanceId: null;
    currentFileIndex: number;
    selectedFiles: File | null;
    selectedStatusFilter: string;
    totalCount: any;
    queryStatusId: any;
    statusId: any;
    ActivestatusId: any;
    isReprocessDialogOpen: boolean;
    decodedTokenJson: any,
    userId: undefined,
    SelectedJob: any,
    jobInfoStatus: any[];
    statusValueArray: Record<number, string>;
    jobs: any[];
    noJobsFound: boolean;
    filters: Filters;
    brokerId: number;
    brokerList: { Broker_ID: number; vchBrokerName: string }[];
    statusFilterAnchorEl: HTMLElement | null;
    // hasFileForDispatch: any;
    openConfirmDialog: boolean;
    dispatchId: any;
    roleID: any;
    adminUser: any;
}


function getComparator<T>(order: 'asc' | 'desc', orderBy: keyof T): (a: T, b: T) => number {
    return (a, b) => {
        const aValue = a[orderBy];
        const bValue = b[orderBy];

        if (aValue == null) return 1;
        if (bValue == null) return -1;

        const comparison = aValue < bValue ? -1 : aValue > bValue ? 1 : 0;
        return order === 'desc' ? -comparison : comparison;
    };
}

class JobListing extends React.Component<TableProps, State> {
    docTypeArray: Record<number, string> = { 1: "CT", 2: "PT", 3: "CTE", 4: "PTE", 5: "Acord Application", 6: "Carrier Quote", 7: "Proposal", 8: "Schedule", 9: "Binder" };
    docOrder: number[] = [1, 2, 3, 4, 7, 5, 6, 9, 8];
    queryParams = new URLSearchParams(window.location.search);
    brokerList: any;

    constructor(props: TableProps) {
        super(props);
        this.state = {
            rows: [],
            order: 'desc',
            orderBy: 'CreatedOn',
            isDrawerOpen: false,
            selectedRow: null,
            isEditing: false,
            selectedRowIds: [],
            snackbarOpen: false,
            snackbarMessage: '',
            snackbarSeverity: 'success',
            loading: false,
            activities: [],
            errorDetailsArray: [],
            fileInfo: [],
            Remarksinfo: null,
            getJobId: null,
            getChecklistName: null,
            getCSRProKey: null,
            getPolicyKey: null,
            getFormsKey: null,
            getExclusionKey: null,
            isActivityDrawerOpen: false,
            isFileModelOpen: false,
            isErrorCardOpen: false,
            selectedErrorMessage: "",
            searchTerm: '',
            searchQuery: '',
            isDialogOpen: false,
            isDeleteDialogOpen: false,
            isReProcessDialogOpen: false,
            reprocessBrokerId: 0,
            isUpdateDialogOpen: false,
            isReprocessFlow: false,
            isCreateActivityDialogOpen: false,
            selectedJobId: "",
            selectedJobIdforModel: null,
            selectedInstanceId: null,
            currentFileIndex: 0,
            selectedFiles: null,
            statusFilterAnchorEl: null,
            selectedStatusFilter: '',
            totalCount: '',
            page: 0,
            rowsPerPage: 100,
            queryStatusId: 0,
            statusId: this.queryParams.get('statusId') || '0',
            ActivestatusId: '0',
            isReprocessDialogOpen: false,
            decodedTokenJson: undefined,
            userId: undefined,
            SelectedJob: '',
            brokerId: -1,
            brokerList: [],
            // hasFileForDispatch: [],
            openConfirmDialog: false,
            dispatchId: null,
            jobInfoStatus: [],
            jobs: [],
            noJobsFound: false,
            roleID: '',
            adminUser: [],
            statusValueArray: {},
            filters: {
                brokerName: '',
            }
        };
    }

    showSnackbar = (message: string, severity: "success" | "error" | "info" | "warning") => {
        this.setState({ snackbarOpen: true, snackbarMessage: message, snackbarSeverity: severity });
    };

    handleCloseSnackbar = () => {
        this.setState({ snackbarOpen: false });
    };

    handleCloseDialog = () => {
        this.setState({ isDialogOpen: false, selectedJobId: null, selectedInstanceId: null });
    };

    handleDeleteDialogClose = () => {
        this.setState({ isDeleteDialogOpen: false, SelectedJob: null, });
    };

    handleReProcessDialogClose = () => {
        this.setState({ isReProcessDialogOpen: false, SelectedJob: null, selectedJobId: null, reprocessBrokerId: 0 });
    };

    handleUpdateStatusDialogClose = () => {
        this.setState({ isUpdateDialogOpen: false, SelectedJob: null, });
    };

    componentDidMount(): void {
        const queryParams = new URLSearchParams(window.location.search);
        const statusId = queryParams.get('statusId') || '0';

        this.setState({ statusId, ActivestatusId: statusId, queryStatusId: statusId }, async () => {
            await this.loadInitialData();
        });

        const token = sessionStorage.getItem('token');
        if (token) {
            const decodedToken = decodeJwt(token);
            if (decodedToken) {
                this.setState({ decodedTokenJson: decodedToken, userId: decodedToken.UserId, roleID: parseInt(decodedToken?.RoleId) });
            } else {
                console.warn("Token decoding failed or returned null");
            }
        }

        // this.loadInitialData();
    }

    loadInitialData = async () => {
        this.setState({ loading: true });

        try {
            await Promise.all([
                this.fetchBrokers(),
                this.fetchJobInfoStatus(),
                this.fetchExdionAdminUSer(),
                this.fetchJobs()
            ]);
        } catch (error) {
            console.error("Error loading initial data:", error);
            this.showSnackbar("Failed to load initial data", "error");
        } finally {
            this.setState({ loading: false });
        }
    };

    fetchJobInfoStatus = async () => {
        try {
            const statusData = await getJobinfostatus();
            const statusMap: Record<number, string> = {};
            statusData.forEach((item: { Id: number, Name: string }) => {
                statusMap[item.Id] = item.Name;
            });

            this.setState({
                jobInfoStatus: statusData || [],
                statusValueArray: statusMap
            });
        } catch (error) {
            console.error('Error fetching job info status:', error);
        }
    };

    fetchBrokers = async () => {
        try {
            const brokerData = await getbroker();
            this.setState({ brokerList: brokerData?.sort((a: any, b: any) => a?.vchBrokerName.localeCompare(b?.vchBrokerName)) || [] });
        } catch (error) {
            console.error('Error fetching brokers:', error);
        }
    };

    fetchExdionAdminUSer = async () => {
        try {
            const token: any = sessionStorage.getItem('token');
            const decodedToken = decodeJwt(token);

            const adminUserRes = await getAdminAccessforUser(decodedToken?.Email, token);
            this.setState({ adminUser: adminUserRes });
        } catch (error) {
            console.error('Error fetching brokers:', error);
        }
    };

    fetchJobs = async () => {
        const { page, rowsPerPage, brokerId, statusId, searchQuery, queryStatusId } = this.state;
        const brokerFilter = brokerId === -1 ? undefined : brokerId;

        let statusFilter: number | undefined = undefined;
        if (statusId !== undefined && statusId !== null && statusId !== '' && statusId !== '0') {
            const num = Number(statusId);
            if (!isNaN(num)) {
                statusFilter = num;
            }
        }

        this.setState({ loading: true });
        try {
            const response = await fetchJob(
                page,
                rowsPerPage,
                brokerFilter,
                statusFilter,
                searchQuery,
                undefined,
                (queryStatusId === statusId && queryStatusId !== "0")
            );

            const updatedArryData = response?.data?.map((item: any) => ({
                ...item,
                Status: (item?.Status === null || item?.Status === "") ? 1 : item?.Status
            }))

            const allJobs = updatedArryData || [];
            // const hasChecklistJobs = allJobs.filter((job: any) => job?.Checklist !== null && job?.Checklist !== '');
            if (response?.data?.length > 0) {
                this.setState({
                    rows: allJobs,
                    totalCount: response.totalCount,
                    // hasFileForDispatch: hasChecklistJobs
                });
                this.showSnackbar('Jobs fetched successfully!', 'success');
            } else {
                this.setState({ rows: [], totalCount: 0 });

                if (statusFilter !== undefined) {
                    this.showSnackbar('No JobIds found for the selected status.', 'error');
                } else if (brokerFilter !== undefined) {
                    this.showSnackbar('No data found for the selected broker.', 'error');
                } else {
                    this.showSnackbar('No jobs found.', 'error');
                }
            }
        } catch (error) {
            console.error('Error fetching jobs:', error);
            this.showSnackbar('Failed to fetch jobs.', 'error');
        } finally {
            this.setState({ loading: false });
        }
    };

    handleRequestSort = (_: React.MouseEvent<unknown>, property: keyof Data) => {
        const isAsc = this.state.orderBy === property && this.state.order === 'asc';
        this.setState({ order: isAsc ? 'desc' : 'asc', orderBy: property });
    };

    handleChangePage = (_: unknown, newPage: number) => {
        this.setState({ page: newPage }, () => {
            this.fetchJobs();
        });
    };

    handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
        const newRowsPerPage = parseInt(event.target.value, 10);
        this.setState({ rowsPerPage: newRowsPerPage, page: 0 }, () => {
            this.fetchJobs();
        });
    };

    handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const term = event.target?.value || '';
        const trimmedTerm = term.trim();

        this.setState({ searchTerm: trimmedTerm }, () => {
            if (trimmedTerm === '') {
                this.setState(
                    {
                        searchQuery: '',
                        selectedStatusFilter: '',
                        statusId: 0,
                        page: 0,
                    },
                    () => {
                        this.fetchJobs();
                    }
                );
            }
        });
    };

    handleSearchKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
        const isEnter = event.key === 'Enter';
        const isSpace = event.key === ' ' || event.keyCode === 32;

        if (isEnter || isSpace) {
            event.preventDefault();
            this.handleSearchClick();
        }
    };

    handleSearchClick = async () => {
        const { brokerId, rowsPerPage, searchTerm } = this.state;
        const validRowsPerPage = rowsPerPage > 0 ? rowsPerPage : 10;
        const brokerFilter = brokerId === -1 ? undefined : brokerId;

        this.setState({
            loading: true,
            searchQuery: searchTerm,
            selectedStatusFilter: '',
            statusId: 0,
            page: 0
        }, async () => {
            try {
                const searchResponse = await fetchJob(
                    0,
                    validRowsPerPage,
                    brokerFilter,
                    0,
                    searchTerm.trim()
                );
                this.setState({
                    rows: searchResponse?.data || [],
                    totalCount: searchResponse?.totalCount || 0
                });
            } catch (error) {
                console.error('Error in searching jobs:', error);
                this.showSnackbar('Failed to search jobs.', 'error');
            } finally {
                this.setState({ loading: false });
            }
        });
    };

    handleViewClick = (id: any, jobId: any) => async () => {
        this.setState({ loading: true });
        try {
            const getDataForJobidActivityStatus = await viewJobActivityDetail(id);
            if (getDataForJobidActivityStatus && getDataForJobidActivityStatus?.Activities?.length > 0) {
                const findRowData = this.state.rows?.find((f: any) => f?.JobId === jobId)?.Status;
                const findDispatchedDate = this.state.rows?.find((f: any) => f?.JobId === jobId)?.DispatchedOn;
                const jobIdStatus = newstatusValueArray[findRowData];
                const dispatchObj = {
                    "ActivityName": "Dispatched",
                    "StatusID": ["Dispatched"].includes(jobIdStatus) ? "Completed" : ["Dispatch Failed"].includes(jobIdStatus) ? "Failed" : "Pending",
                    "Order": 8,
                    "Updatedon": findDispatchedDate
                };
                const appendNewObj = [...getDataForJobidActivityStatus?.Activities, dispatchObj];

                this.setState({
                    activities: appendNewObj || [],
                    isActivityDrawerOpen: true,
                    selectedJobIdforModel: id,
                    SelectedJob: jobId
                });
            }
        } catch (error) {
            this.setState({
                activities: [],
                isActivityDrawerOpen: true,
                selectedJobIdforModel: id,
                SelectedJob: jobId
            });

            console.error('Error fetching jobid activity details:', error);
        } finally {
            this.setState({ loading: false });
        }
    };

    handleOpenReprocessDialog = () => {
        const firstActivity = this.state.activities.find(
            act => act.Order === 1 || act.ActivityName === "JobFileProcess"
        );

        if (firstActivity) {
            this.setState({
                selectedInstanceId: firstActivity.InstanceID,
                isDialogOpen: true,
                isReprocessFlow: true,
            });
        } else {
            this.showSnackbar("No eligible activity found to reprocess", "warning");
        }
    };

    handleRefreshJobTable = () => async () => {
        this.setState({ isActivityDrawerOpen: false, SelectedJob: '', isErrorCardOpen: false })
        await new Promise(resolve => setTimeout(resolve, 1000));
        await this.fetchJobs();
    };

    renderActivityModel = () => {
        const { rows, activities, isActivityDrawerOpen, SelectedJob, isErrorCardOpen, errorDetailsArray, adminUser, isDialogOpen, currentFileIndex, roleID, decodedTokenJson } = this.state;
        const data = this.state?.activities;
        const orderSet = data.sort((a, b) => a.Order - b.Order);
        // const currentStatus = rows?.find(f => f?.JobId === SelectedJob)?.Status;

        const lastErrorIndex = errorDetailsArray?.length - 1;

        return (
            <Modal open={isActivityDrawerOpen} onClose={() => this.setState({ isActivityDrawerOpen: false, SelectedJob: '' })}>
                <Box sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    height: 'auto',
                    maxHeight: '90%',
                    width: '80%',
                    overflow: 'auto',
                    transform: 'translate(-50%, -50%)',
                    bgcolor: 'background.paper',
                    boxShadow: 24,
                    padding: '15px',
                    borderRadius: 2
                }}>

                    <Grid container spacing={1}>
                        <Grid item xs={12}>
                            <Typography variant="h6" gutterBottom>
                                Activity Details
                            </Typography>
                        </Grid>

                        <Grid item xs={12}>
                            <Grid container justifyContent="space-between" alignItems="center" sx={{ mb: 2 }}>
                                <Grid item>
                                    <Box display="flex" alignItems="center">
                                        <Typography variant="body1" sx={{ mr: 2 }}>
                                            Job Id: {this.state.SelectedJob}
                                        </Typography>
                                        <Tooltip title="Refresh Activities table">
                                            <Refresh
                                                sx={{
                                                    cursor: "pointer",
                                                    color: "blue",
                                                    boxShadow: 'rgba(0, 0, 0, 0.16) 0px 1px 4px',
                                                }}
                                                onClick={this.handleViewClick(this.state.selectedJobIdforModel, this.state.SelectedJob)}
                                            />
                                        </Tooltip>
                                    </Box>
                                </Grid>

                                <Grid item>
                                    <Box display="flex" gap={2}>
                                        {orderSet.length === 0 && adminUser?.data?.Role?.includes("report") ? (
                                            <Button
                                                variant="contained"
                                                color="success"
                                                size="small"
                                                fullWidth
                                                sx={{
                                                    textTransform: "none",
                                                    fontWeight: "bold",
                                                    borderRadius: "8px",
                                                    height: '30px',
                                                    fontSize: "12px"
                                                }}
                                                onClick={() => this.setState({ isCreateActivityDialogOpen: true })}
                                            >
                                                Create Activity
                                            </Button>
                                        ) : null}
                                        {orderSet.length !== 0 && adminUser?.data?.Role?.includes("report") ? (
                                            <Tooltip title="Reprocess first activity">
                                                <Button
                                                    variant="contained"
                                                    color="warning"
                                                    size="small"
                                                    sx={{
                                                        textTransform: "none",
                                                        fontWeight: "bold",
                                                        borderRadius: "8px",
                                                        height: '30px',
                                                        fontSize: "12px",
                                                    }}
                                                    onClick={this.handleOpenReprocessDialog}
                                                    disabled={orderSet.length === 0}
                                                >
                                                    Reprocess
                                                </Button>
                                            </Tooltip>
                                        ) : null}

                                        <Button
                                            variant="contained"
                                            color="primary"
                                            size="small"
                                            sx={{
                                                textTransform: "none",
                                                fontWeight: "bold",
                                                borderRadius: "8px",
                                                height: '30px',
                                            }}
                                            onClick={this.handleRefreshJobTable()}
                                        >
                                            Close
                                        </Button>
                                    </Box>
                                </Grid>
                            </Grid>
                        </Grid>

                        {/* <Grid item xs={12}>
                            <Typography variant="body1">
                                Current Status:
                                <Box
                                    component="span"
                                    sx={{
                                        marginLeft: '8px',
                                        paddingLeft: '11px',
                                        paddingRight: '15px',
                                        paddingTop: '0px',
                                        paddingBottom: '4px',
                                        borderRadius: '20px',
                                        fontSize: '14px',
                                        fontWeight: 500,
                                        backgroundColor: getStatusColor(currentStatus).bg,
                                        color: getStatusColor(currentStatus).text,
                                    }}
                                >
                                    {newstatusValueArray[currentStatus]}
                                </Box>
                            </Typography>
                        </Grid> */}
                    </Grid>


                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell sx={{ border: '1px solid #ddd', fontSize: '11px', fontWeight: 'bold' }}>S.No</TableCell>
                                <TableCell sx={{ border: '1px solid #ddd', fontSize: '11px', fontWeight: 'bold' }}>Activity Name</TableCell>
                                <TableCell sx={{ border: '1px solid #ddd', fontSize: '11px', fontWeight: 'bold' }}>Status</TableCell>
                                <TableCell sx={{ border: '1px solid #ddd', fontSize: '11px', fontWeight: 'bold' }}>Created At</TableCell>
                                <TableCell sx={{ border: '1px solid #ddd', fontSize: '11px', fontWeight: 'bold' }}>Updated On</TableCell>
                                {(roleID !== UserRole.QA || (roleID === UserRole.QA && adminUser?.data?.Role?.includes("report"))) && (
                                    <TableCell sx={{ border: '1px solid #ddd', fontSize: '11px', fontWeight: 'bold' }}>Actions</TableCell>
                                )}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {orderSet.length === 0 ? (
                                <TableRow>
                                    <TableCell colSpan={6} align="center" sx={{ fontSize: '12px' }}>
                                        No activities found for this Job ID.
                                    </TableCell>
                                </TableRow>
                            ) : (orderSet?.map((activity, index) => {
                                const statusNo = statusValueFilterArray[activity?.StatusID];
                                const { bg, text } = getStatusColorActivity(statusNo);

                                return (
                                    <TableRow key={activity.InstanceID}>
                                        <TableCell sx={{ border: '1px solid #ddd', fontSize: '11px' }}>{index + 1}</TableCell>
                                        <TableCell sx={{ border: '1px solid #ddd', fontSize: '11px' }}>{activity?.ActivityName}</TableCell>
                                        <TableCell sx={{ border: '1px solid #ddd', fontSize: '11px' }}>
                                            <Chip
                                                label={activity?.StatusID}
                                                sx={{
                                                    backgroundColor: bg,
                                                    color: text,
                                                    fontWeight: "bold",
                                                    fontSize: "10px",
                                                    height: "20px",
                                                    borderRadius: "20px",
                                                    border: "none",
                                                }}
                                            />
                                        </TableCell>
                                        <TableCell sx={{ border: '1px solid #ddd', fontSize: '11px' }}> {activity?.CreatedAt ? new Date(activity.CreatedAt).toLocaleString() : ""}</TableCell>
                                        <TableCell sx={{ border: '1px solid #ddd', fontSize: '11px' }}>
                                            {(activity?.StatusID === "Failed" || activity?.StatusID === "Completed") && activity?.Updatedon
                                                ? new Date(activity.Updatedon).toLocaleString("en-US", {
                                                    month: "numeric",
                                                    day: "numeric",
                                                    year: "numeric",
                                                    hour: "numeric",
                                                    minute: "numeric",
                                                    second: "numeric",
                                                    hour12: true,
                                                })
                                                : ""}
                                        </TableCell>

                                        {(roleID !== UserRole.QA || (roleID === UserRole.QA && adminUser?.data?.Role?.includes("report"))) && (
                                            <TableCell sx={{ border: '1px solid #ddd', fontSize: '11px' }}>
                                                {activity.StatusID === "Failed" && (
                                                    <>
                                                        <Tooltip title={`Click here to see the Error in ${activity.ActivityName}`}>
                                                            <Visibility
                                                                sx={{ cursor: "pointer", color: "red" }}
                                                                onClick={this.handleActivityErrorViewClick(activity.InstanceID)} />
                                                        </Tooltip>
                                                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                        {orderSet.length !== 0 && adminUser?.data?.Role?.includes("report") ? (
                                                            <Tooltip title={`Click here to retry ${activity.ActivityName}`}>

                                                                <Cached
                                                                    sx={{ cursor: "pointer", color: "red" }}
                                                                    onClick={() => this.handleAlertDailogForRetrigger(activity.InstanceID)} />

                                                            </Tooltip>
                                                        ) : null}

                                                    </>
                                                )}
                                                {
                                                    (["pushpak_k@exdioninsurance.com", "gokul@x-academy.in", "ramu_s@exdioninsurance.com", "sanjay_joyit@exdioninsurance.com"]?.includes(decodedTokenJson?.Email?.trim()?.toLowerCase())) && activity.StatusID === "Completed" && (
                                                        <Tooltip title={`Click here to retry ${activity.ActivityName}`}>
                                                            <Cached
                                                                sx={{ cursor: "pointer", color: "blue" }}
                                                                onClick={() => this.handleAlertDailogForRetrigger(activity.InstanceID)} />
                                                        </Tooltip>
                                                    )
                                                }
                                            </TableCell>
                                        )}
                                    </TableRow>
                                )
                            }))}

                        </TableBody>
                    </Table>

                    {/* Confirmation Dailog for Create Activity Dialog */}
                    <Dialog
                        open={this.state.isCreateActivityDialogOpen}
                        onClose={() => this.setState({ isCreateActivityDialogOpen: false })}
                    >
                        <DialogContent sx={{
                            padding: '0px 25px',
                            paddingTop: '25px',
                            paddingBottom: '25px',
                            textAlign: 'center',
                        }}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    mb: 2,
                                }}
                            >
                                <Box
                                    sx={{
                                        backgroundColor: '#ECFDF5',
                                        borderRadius: '50%',
                                        width: 60,
                                        height: 60,
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                    }}
                                >
                                    <FlipCameraAndroid sx={{ color: '#047857', fontSize: 30 }} />
                                </Box>
                            </Box>
                            <DialogTitle sx={{ textAlign: 'center', fontWeight: 'bold', fontSize: '1.25rem', p: 0 }}>Confirm Activity Creation</DialogTitle>
                            <DialogContentText sx={{ textAlign: 'center', mt: 1, mb: 3, color: 'rgba(0, 0, 0, 0.7)' }}>
                                Are you sure you want to Create New Activity
                            </DialogContentText>
                            <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2, height: '30px' }}>
                                <Button
                                    color="primary"
                                    variant="contained"
                                    autoFocus
                                    onClick={async () => {
                                        const { selectedJobIdforModel } = this.state;
                                        await this.handleReCreateJobid(selectedJobIdforModel);
                                        this.handleViewClick(selectedJobIdforModel, this.state.SelectedJob)();
                                        this.setState({ isCreateActivityDialogOpen: false });
                                    }}
                                >
                                    Yes
                                </Button>
                                <Button
                                    onClick={() => this.setState({ isCreateActivityDialogOpen: false })}
                                    sx={{
                                        color: '#007bff',
                                        borderColor: '#007bff',
                                        border: '0.5px solid #53494987',
                                        // px: 4,
                                        // borderRadius: '6px',
                                        '&:hover': {
                                            borderColor: '#0056b3',
                                            color: '#0056b3',
                                        },
                                    }}
                                >
                                    No
                                </Button>
                            </Box>
                        </DialogContent>
                    </Dialog>


                    {/* Confirmation Dialog for reprocess & retrigger*/}
                    <Dialog open={isDialogOpen} onClose={this.handleCloseDialog}>
                        <DialogContent sx={{
                            padding: '0px 0px',
                            paddingTop: '15px',
                            paddingBottom: '15px',
                            textAlign: 'center',
                        }}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    mb: 2,
                                }}
                            >
                                <Box
                                    sx={{
                                        backgroundColor: '#FEF9C3',
                                        borderRadius: '50%',
                                        width: 60,
                                        height: 60,
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                    }}
                                >
                                    <Cached sx={{ color: '#CA8A04', fontSize: 30 }} />
                                </Box>
                            </Box>
                            <DialogTitle sx={{ textAlign: 'center', fontWeight: 'bold', fontSize: '1.25rem', p: 0 }}>Confirm Job Trigger</DialogTitle>
                            <DialogContent>
                                <DialogContentText sx={{ textAlign: 'center', mt: 1, mb: 3, color: 'rgba(0, 0, 0, 0.7)' }}>
                                    Are you sure you want to retrigger the selected process?
                                </DialogContentText>
                            </DialogContent>
                            <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2, height: '30px' }}>
                                <Button onClick={this.handleConfirmationForRetrigger} color="primary" variant="contained" autoFocus>
                                    Yes
                                </Button>
                                <Button onClick={this.handleCloseDialog} sx={{
                                    color: '#007bff',
                                    borderColor: '#007bff',
                                    border: '0.5px solid #53494987',
                                    // px: 4,
                                    // borderRadius: '6px',
                                    '&:hover': {
                                        borderColor: '#0056b3',
                                        color: '#0056b3',
                                    },
                                }}>
                                    No
                                </Button>
                            </Box>
                        </DialogContent>
                    </Dialog>

                    {isErrorCardOpen && (
                        <Card sx={{ overflow: 'hidden', height: 'auto', margin: '5px 0px 5px 0px', position: "relative", p: 2, bgcolor: "#ffebee" }}>
                            <IconButton
                                onClick={() => this.setState({ isErrorCardOpen: false, currentFileIndex: 0 })}
                                sx={{ position: "absolute", right: 10, top: 10, boxShadow: 'rgba(0, 0, 0, 0.16) 0px 1px 4px' }}
                            >
                                <Close />
                            </IconButton>

                            <CardContent>
                                {errorDetailsArray?.length > 0 ? (
                                    <Box
                                        sx={{
                                            borderBottom: "1px solid #ddd",
                                            textAlign: "center",
                                        }}
                                    >
                                        <Typography variant="subtitle1">
                                            <b>Error</b>
                                        </Typography>
                                        <Typography color="error" variant="body2" sx={{ border: '1px solid #ddd', fontSize: '15px', fontWeight: 'bold' }}> ErrorDetails: {errorDetailsArray[lastErrorIndex]?.ErrorDetails}</Typography>
                                    </Box>
                                ) : (
                                    <Typography variant="body2" color="textSecondary">
                                        No error information available.
                                    </Typography>
                                )}
                            </CardContent>
                        </Card>
                    )}
                </Box>
            </Modal>
        );
    };

    handleActivityErrorViewClick = (id: string) => async () => {
        this.setState({ loading: true });
        try {
            const getErrorMsgofSelectedActivity = await viewErrorForSelectedActivityName(id);
            if (getErrorMsgofSelectedActivity && getErrorMsgofSelectedActivity?.length > 0) {
                this.setState({
                    errorDetailsArray: getErrorMsgofSelectedActivity || [],
                    isErrorCardOpen: true,
                });
            }
        } catch (error) {
            this.showSnackbar("Failed to display the error_details ", 'error');
            console.error('Error fetching errordetails:', error);
        } finally {
            this.setState({ loading: false });
        }
    };

    handleAlertDailogForRetrigger = (InstanceID: any) => {
        this.setState((prevState) => ({
            isDialogOpen: true,
            selectedInstanceId: InstanceID,
            isReprocessFlow: false,
        }));
        // this.setState({ isDialogOpen: true, selectedInstanceId: InstanceID });
    };

    handleConfirmationForRetrigger = () => {
        const { selectedInstanceId, selectedJobIdforModel } = this.state;
        if (selectedInstanceId) {
            this.handleRetryProcessCall(selectedInstanceId, selectedJobIdforModel);
        }
        this.handleCloseDialog();
    };


    handleConfirmReprocess = async () => {
        const { activities, selectedJobIdforModel } = this.state;
        this.setState({ loading: true, isReprocessDialogOpen: false });

        try {
            const targetActivity = activities.find(
                activity => activity.Order === 1 || activity.ActivityName === "JobFileProcess"
            );

            if (targetActivity) {
                await this.handleRetryProcessCall(targetActivity.InstanceID, selectedJobIdforModel);
            } else {
                this.showSnackbar("No matching activity found to reprocess.", 'warning');
            }
        } catch (error) {
            console.error('Error during reprocess:', error);
            this.showSnackbar("Failed to reprocess the activity.", 'error');
        } finally {
            this.setState({ loading: false });
        }
    };


    handleRetryProcessCall = async (InstanceID: any, selectedJobIdforModel: any) => {
        this.setState({ loading: true });

        try {
            const retriggerCallforFailedActivity = await retriggerTheFailedActivityStatusAgain(InstanceID, selectedJobIdforModel);
            if (retriggerCallforFailedActivity?.status === 200) {
                this.showSnackbar('The job process triggered successfully, the table data get refreshing...', 'success');
                await new Promise(resolve => setTimeout(resolve, 1000));
                await this.handleViewClick(this.state.selectedJobIdforModel, this.state.SelectedJob)();
            }
        } catch (error) {
            console.error('Error in retry the jobs:', error);
            this.showSnackbar('Failed to retry the activity.', 'error');
        } finally {
            this.setState({ loading: false });
        }
    };

    handleFileInfoClick = (id: string, JobId: string) => async () => {
        this.setState({ loading: true });
        try {
            const fileRemarksResponse = await viewUploadedFileRemarks(id);
            const fileInfoResponse = await viewUploadedFileForDownload(id);
            const consolidatedFiles = await getFilesFromS3OutputPath(JobId);

            const getCSRProKey = consolidatedFiles?.find((file: any) => file?.FileName?.includes("_CSR Pro"))?.S3Key || "";
            const getPolicyKey = consolidatedFiles?.find((file: any) => file?.FileName?.includes("_SummaryChecklist"))?.S3Key || "";
            const getFormsKey = consolidatedFiles?.find((file: any) => file?.FileName?.includes("_FormsCompare"))?.S3Key || "";
            const getExclusionKey = consolidatedFiles?.find((file: any) => file?.FileName?.includes("_Exclusions"))?.S3Key || "";

            const updatedFileInfo = fileInfoResponse?.map((fileObj: any, index: any) => ({
                ...fileObj,
                rowId: index + 1
            })) || [];

            this.setState({
                getJobId: fileRemarksResponse?.JobId || "",
                getChecklistName: fileRemarksResponse?.Checklist || "",
                getCSRProKey: getCSRProKey,
                getPolicyKey: getPolicyKey,
                getFormsKey: getFormsKey,
                getExclusionKey: getExclusionKey,
                Remarksinfo: fileRemarksResponse?.Remarks || "",
                fileInfo: updatedFileInfo,
                isFileModelOpen: true,
                SelectedJob: JobId,
            });


        } catch (error) {
            this.showSnackbar("Failed to fetch fileInfo", 'error');
            console.error('Error fetching fileInfo:', error);
        } finally {
            this.setState({ loading: false });
        }
    };

    handleDeleteClick = (jobId: string) => async () => {
        this.setState({ loading: true });
        try {
            const deleteResponse = await DeleteJob(jobId);
            if (deleteResponse?.message) {
                this.showSnackbar(deleteResponse.message, 'success');
                await new Promise(resolve => setTimeout(resolve, 2000));
                await this.fetchJobs();
            }
        } catch (error) {
            this.showSnackbar("Failed to delete the job.", 'error');
            console.error('Error deleting job:', error);
        } finally {
            this.setState({ loading: false, isDeleteDialogOpen: false, SelectedJob: null });
        }
    };

    handleReprocessClick = (jobId: string, Id: string) => async () => {
        this.setState({ loading: true });
        try {
            const response = await tranferJob(Id, jobId, this.state.reprocessBrokerId);
            if (response) {
                await triggerTheJobIdToCreateAgain(response?.Id, "PolicyCheckListProcess");
                this.setState({
                    loading: false,
                    snackbarOpen: true, snackbarMessage: `The Job created successfully! \n JobId: ${response?.JobId}`,
                    snackbarSeverity: 'success'
                });
            }
        } catch (error) {
            this.showSnackbar("Failed to Reprocess the job: " + jobId, 'error');
            console.error('Error deleting job:', error);
        } finally {
            this.setState({ loading: false });
            this.handleReProcessDialogClose()
        }
    };

    handleJobStatusUpdate = (jobId: string) => async () => {
        this.setState({ loading: true });
        try {
            const updateResponse = await UpdateJobStatus(jobId);
            if (updateResponse?.message) {
                this.showSnackbar(`${jobId} status was ${updateResponse.message}`, 'success');
                await new Promise(resolve => setTimeout(resolve, 2000));
                await this.fetchJobs();
            }
        } catch (error) {
            this.showSnackbar("Failed to update the jobid status.", 'error');
            console.error('Error deleting job:', error);
        } finally {
            this.setState({ loading: false, isUpdateDialogOpen: false, SelectedJob: null });
        }
    };

    handleOpenConfirmDialog = (jobId: any, row_jobid: any) => {
        this.setState({ openConfirmDialog: true, dispatchId: jobId, SelectedJob: row_jobid });
    };

    handleCloseConfirmDialog = () => {
        this.setState({ openConfirmDialog: false, dispatchId: null });
    };

    handleDispatchJobIdClick = (id: string) => async () => {
        this.setState({ loading: true });
        try {
            const dispatchMsgResponse = await DispatchJobId(id);
            if (dispatchMsgResponse) {
                this.showSnackbar(dispatchMsgResponse, 'success');
                this.setState(prevState => ({
                    rows: prevState.rows.map(row =>
                        row.Id === id ? { ...row, Status: 26 } : row
                    )
                }));
            }
        } catch (error) {
            this.showSnackbar("Failed to dispatch the selected_job", 'error');
            console.error('Error in dispatching job:', error);
        } finally {
            this.setState({ loading: false, openConfirmDialog: false, dispatchId: null });
        }
    };

    renderFileInfoDrawer = () => {
        const { fileInfo, isFileModelOpen, Remarksinfo, getJobId, getChecklistName, getCSRProKey, getPolicyKey, getFormsKey, getExclusionKey, rows } = this.state;
        const selecteRow = rows.find(row => row.JobId === getJobId);
        const consolidatedFileName = getChecklistName?.split('.xlsx')[0];

        const downloadFile = async (bucketName: string, fileName: string, name: string) => {
            const fileInfoPath = fileName?.split('.com/');
            try {
                const blobUrlForFile = await generateURLForDownloadInputFiles(bucketName, fileInfoPath);
                if (blobUrlForFile) {
                    handleDownload(blobUrlForFile, name);
                    this.showSnackbar(`The selected file ${name} downloaded successfully!`, 'success');
                }
            } catch (error) {
                this.showSnackbar("There is an error in downloading the file", 'error');
                console.error('Error in downloading:', error);
            }
        };

        const discrepancy_downloadFile = async (getJobId: string) => {
            try {
                const token = sessionStorage.getItem('token');
                const url = `${baseUrl1}api/Policy/export-policy-data/${getJobId}`;
                const Token = await expTokenProcessAndGenerate(token);
                const response = await fetch(url, {
                    method: 'GET',
                    headers: {
                        'accept': 'application/json',
                        'Authorization': `Bearer ${Token}`
                    }
                });
                if (response.ok) {
                    const blob = await response.blob();
                    const contentDisposition = response.headers.get('content-disposition');
                    const fileName = `${getJobId}_discrepancy.xlsx`;
                    const blobUrl = window.URL.createObjectURL(blob);
                    const link = document.createElement('a');
                    link.href = blobUrl;
                    link.setAttribute('download', fileName);
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    window.URL.revokeObjectURL(blobUrl);
                    this.showSnackbar(`The selected ${getJobId}_discrepancy.xlsx downloaded successfully!`, 'success');
                } else {
                    throw new Error('Failed to download file: ' + response.statusText);
                }
            } catch (error) {
                console.error('Error in downloading:', error);
                this.showSnackbar("There is an error in downloading the file", 'error');
            }
        };

        const GenrateChecklist_downloadFile = async (s3url: string, Filename: string) => {
            try {
                const token = sessionStorage.getItem('token');
                const Token = await expTokenProcessAndGenerate(token);
                const url = `${baseUrl}api/FileManager/DownloadFileByS3FileName?fileName=${encodeURIComponent(s3url)}`;

                const response = await fetch(url, {
                    method: 'GET',
                    headers: {
                        'accept': 'application/octet-stream',
                        'Authorization': `Bearer ${Token}`
                    }
                });

                if (response.ok) {
                    const blob = await response.blob();
                    const fileName = `${Filename}`;
                    const blobUrl = window.URL.createObjectURL(blob);
                    const link = document.createElement('a');
                    link.href = blobUrl;
                    link.setAttribute('download', fileName);
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    window.URL.revokeObjectURL(blobUrl);

                    this.showSnackbar(`The selected ${Filename} downloaded successfully!`, 'success');
                } else {
                    throw new Error('Failed to download file: ' + response.statusText);
                }
            } catch (error) {
                console.error('Error in downloading:', error);
                this.showSnackbar("There is an error in downloading the file", 'error');
            }
        };

        const downloadConsolidatedFile = async (s3url: string, Filename: string) => {
            try {
                this.setState({ loading: true });
                const token = sessionStorage.getItem('token');
                const Token = await expTokenProcessAndGenerate(token);
                const url = `${baseUrl}api/FileManager/DownloadFileByS3FileName?fileName=${encodeURIComponent(s3url)}`;

                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", Filename);

                const response = await fetch(url, {
                    method: 'GET',
                    headers: {
                        'Authorization': `Bearer ${Token}`
                    }
                });

                if (!response.ok) {
                    throw new Error('Failed to download file');
                }

                const blob = await response.blob();
                const blobUrl = window.URL.createObjectURL(blob);
                link.href = blobUrl;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(blobUrl);
                this.showSnackbar(`${Filename} downloaded successfully!`, 'success');
            } catch (error) {
                console.error('Error in downloading:', error);
                this.showSnackbar("There is an error in downloading the file", 'error');

            } finally {
                this.setState({ loading: false });
            }
        };

        return (
            <Modal
                open={isFileModelOpen}
                onClose={() => this.setState({ isFileModelOpen: false })}
                aria-labelledby="file-info-modal"
                aria-describedby="file-information-details"
            >

                <Box sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'flex-start',
                    marginTop: '40px',
                    padding: '16px',
                    height: '100vh',
                    overflow: 'auto',
                }}>
                    <Card sx={{
                        width: '90%',
                        maxWidth: '1000px',
                        maxHeight: '90vh',
                        overflowY: 'auto',
                        overflowX: 'hidden',
                        borderRadius: '12px',
                        padding: '15px',
                        boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
                        backgroundColor: '#fff',
                    }}>
                        <Grid container spacing={1}>
                            <Grid item xs={12}>
                                <Grid container justifyContent="space-between" alignItems="center" sx={{ mb: 1 }}>
                                    <Grid item>
                                        <Box display="flex" alignItems="center">
                                            <Typography variant="h6" gutterBottom>
                                                <span style={{ color: '#ab9e9ed6' }}> View   </span>
                                            </Typography>
                                        </Box>
                                    </Grid>

                                    <Grid item>
                                        <Box display="flex" gap={1}>
                                            <IconButton onClick={() => this.setState({ isFileModelOpen: false })} className="close-button">
                                                <Close />
                                            </IconButton>
                                        </Box>
                                    </Grid>
                                </Grid>
                            </Grid>

                            <Grid item xs={12}>
                                <Typography >
                                    Job Id : {this.state.SelectedJob}
                                </Typography>
                            </Grid>
                        </Grid>

                        <CardContent className="card-section">
                            <Typography variant="h6" gutterBottom>Input Files</Typography>
                            <TableContainer component={Paper} elevation={3}>
                                <Table stickyHeader>
                                    <TableHead>
                                        <TableRow>
                                            {["Sl No", "File Name", "Doc_fieldType", "File Size", "File Type", "Action"].map((head) => (
                                                <TableCell key={head}>{head}</TableCell>
                                            ))}
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {fileInfo.length === 0 ? (
                                            <TableRow>
                                                <TableCell colSpan={6}>No Input Files Found</TableCell>
                                            </TableRow>
                                        ) : (
                                            [...fileInfo]
                                                .sort((a, b) => this.docOrder.indexOf(a?.FileForId) - this.docOrder.indexOf(b?.FileForId))
                                                .map((file, index) => (
                                                    <TableRow key={file?.id || index}>
                                                        <TableCell>{index + 1}</TableCell>
                                                        <TableCell>{file?.FileName}</TableCell>
                                                        <TableCell>{this.docTypeArray[file?.FileForId]}</TableCell>
                                                        <TableCell>
                                                            {file?.FileSize
                                                                ? `${(Number(file?.FileSize) / (1024 * 1024)).toFixed(2)} MB`
                                                                : "-"}
                                                        </TableCell>
                                                        <TableCell>{`.${file?.FileType}`}</TableCell>
                                                        <TableCell>
                                                            <Tooltip title="Download File">
                                                                <IconButton
                                                                    color="primary"
                                                                    size="small"
                                                                    onClick={() =>
                                                                        downloadFile(bucketName, file?.PublishedFilePath, file?.FileName)
                                                                    }
                                                                >
                                                                    <Download fontSize="small" />
                                                                </IconButton>
                                                            </Tooltip>
                                                        </TableCell>
                                                    </TableRow>
                                                ))
                                        )}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </CardContent>


                        <CardContent className="card-section1">
                            <Typography variant="h6" gutterBottom>Output Files</Typography>
                            <TableContainer component={Paper} elevation={3}>
                                <Table stickyHeader>
                                    <TableHead>
                                        <TableRow>
                                            {["File Name", "Action"].map((head) => (
                                                <TableCell key={head}>{head}</TableCell>
                                            ))}
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        <TableRow>
                                            <TableCell>{getJobId}_discrepancy.xlsx</TableCell>
                                            <TableCell>
                                                <Tooltip title="Click to download the file">
                                                    <IconButton
                                                        color="primary"
                                                        className="output-file-download-btn"
                                                        onClick={() => discrepancy_downloadFile(getJobId)}
                                                    >
                                                        <Download />
                                                    </IconButton>
                                                </Tooltip>
                                            </TableCell>
                                        </TableRow>
                                        {getChecklistName != "" ? (
                                            <TableRow>
                                                <TableCell>{getChecklistName}</TableCell>
                                                <TableCell>
                                                    <Tooltip title="Click to download the file">
                                                        <IconButton
                                                            color="primary"
                                                            className="output-file-download-btn"
                                                            onClick={() => GenrateChecklist_downloadFile(`Document/PolicyChecklist/${getJobId}/Output/${getChecklistName}`, getChecklistName)}
                                                        >
                                                            <Download />
                                                        </IconButton>
                                                    </Tooltip>
                                                </TableCell>
                                            </TableRow>) : null}
                                        {getCSRProKey != "" ? (
                                            <TableRow>
                                                <TableCell>{consolidatedFileName}_CSR Pro.pdf</TableCell>
                                                <TableCell>
                                                    <Tooltip title="Click to download the file">
                                                        <IconButton
                                                            color="primary"
                                                            className="output-file-download-btn"
                                                            onClick={() => downloadConsolidatedFile(getCSRProKey, `${consolidatedFileName}_CSR Pro.pdf`)}
                                                        >
                                                            <Download />
                                                        </IconButton>
                                                    </Tooltip>
                                                </TableCell>
                                            </TableRow>) : null}
                                        {getPolicyKey != "" ? (
                                            <TableRow>
                                                <TableCell>{consolidatedFileName}_SummaryChecklist.pdf</TableCell>
                                                <TableCell>
                                                    <Tooltip title="Click to download the file">
                                                        <IconButton
                                                            color="primary"
                                                            className="output-file-download-btn"
                                                            onClick={() => downloadConsolidatedFile(getPolicyKey, `${consolidatedFileName}_SummaryChecklist.pdf`)}
                                                        >
                                                            <Download />
                                                        </IconButton>
                                                    </Tooltip>
                                                </TableCell>
                                            </TableRow>) : null}
                                        {getFormsKey != "" ? (
                                            <TableRow>
                                                <TableCell>{consolidatedFileName}_FormsCompare.pdf</TableCell>
                                                <TableCell>
                                                    <Tooltip title="Click to download the file">
                                                        <IconButton
                                                            color="primary"
                                                            className="output-file-download-btn"
                                                            onClick={() => downloadConsolidatedFile(getFormsKey, `${consolidatedFileName}_FormsCompare.pdf`)}
                                                        >
                                                            <Download />
                                                        </IconButton>
                                                    </Tooltip>
                                                </TableCell>
                                            </TableRow>) : null}
                                        {getExclusionKey != "" ? (
                                            <TableRow>
                                                <TableCell>{consolidatedFileName}_Exclusions.pdf</TableCell>
                                                <TableCell>
                                                    <Tooltip title="Click to download the file">
                                                        <IconButton
                                                            color="primary"
                                                            className="output-file-download-btn"
                                                            onClick={() => downloadConsolidatedFile(getExclusionKey, `${consolidatedFileName}_Exclusions.pdf`)}
                                                        >
                                                            <Download />
                                                        </IconButton>
                                                    </Tooltip>
                                                </TableCell>
                                            </TableRow>) : null}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </CardContent>

                        {/* <CardContent className="card-section">
                            <Typography variant="h6">Remarks</Typography>
                            <Typography className="remarks-text">
                                {Remarksinfo?.length > 0 ? Remarksinfo : ''}
                            </Typography>
                        </CardContent> */}
                    </Card>
                </Box>
            </Modal>

        );
    };

    handleReCreateJobid = async (jobId: any) => {
        this.setState({ loading: true });

        try {
            const jobIdCreateRes = await createJobidForAfterFileUpload(jobId);
            if (jobIdCreateRes?.status === 200) {
                this.showSnackbar('The job trigged succesfully', 'success');
            }
        } catch (error) {
            console.error('Error in triggering the jobs:', error);
            this.showSnackbar('Failed to triggering the.', 'error');
        } finally {
            this.setState({ loading: false });
        }
    };

    handleFileChange = async (event: any, JobId: string) => {
        const input = event?.target as HTMLInputElement;
        const selectedFile = input?.files?.[0];

        if (selectedFile?.name?.split('_')[0]?.trim() != JobId) {
            this.showSnackbar('Mismatch between download and upload job_ID', 'error');
            input.value = "";
            return;
        }

        if (selectedFile) {
            if (selectedFile.type !== 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
                alert("Only .xlsx files are allowed. Please select a valid file.");
                input.value = "";
                return;
            }
            this.setState({ selectedFiles: selectedFile })
            await this.uploadCall(JobId, selectedFile);
        }

        input.value = "";
    };

    uploadCall = async (JobId: any, selectedFiles: any) => {
        this.setState({ loading: true });
        const Token = await expTokenProcessAndGenerate(sessionStorage.getItem("token"));
        const formData = new FormData();
        formData.append('file', selectedFiles);
        formData.append("jobid", JobId.toString());
        try {
            const response = await axios.post(`${baseUrl}api/Upload/UploadDiscrepencyExcel?job_id=${JobId}`, formData,
                {
                    headers: { Authorization: `Bearer ${Token}`, "Content-Type": "multipart/form-data" },
                }
            );
            if (response.status !== 200) {
                this.showSnackbar('Failed to upload the file', 'error');
                return "error";
            }
        }
        catch (error) {
            console.error('error', error);
        } finally {
            this.showSnackbar(`${JobId}_Discrepancy Uploaded successfully `, 'success');
            this.setState({ loading: false });
        }
    };

    handleStatusFilterClick = (event: React.MouseEvent<HTMLElement>) => {
        const url = new URL(window.location.href);
        const ActivestatusId = url.searchParams.get("statusId");
        this.setState({
            searchTerm: '',
            searchQuery: '',
            statusFilterAnchorEl: event.currentTarget,
            ActivestatusId
        });
    };


    handleStatusFilterClose = () => {
        this.setState({ statusFilterAnchorEl: null });
    };

    // handleStatusFilterSelect = async (statusKey: any) => {
    //     const selectedStatus = this.statusValueFilterArray[statusKey];
    //     this.setState({
    //         loading: true,
    //         selectedStatusFilter: statusKey,
    //         statusId: selectedStatus,
    //         page: 0,
    //         searchTerm: '',
    //         searchQuery: '',
    //         statusFilterAnchorEl: null
    //     }, this.fetchJobs);
    // };

    openDeleteDialog = (jobId: string) => {
        this.setState({ isDeleteDialogOpen: true, SelectedJob: jobId });
    };

    openReprocessDialog = (jobId: string, Id: string) => {
        this.setState({ isReProcessDialogOpen: true, SelectedJob: jobId, selectedJobId: Id });
    };

    openUpdateStatusDialog = (jobId: string) => {
        this.setState({ isUpdateDialogOpen: true, SelectedJob: jobId });
    };

    handleBrokerChange = (event: SelectChangeEvent<number>) => {
        const selectedBrokerId = parseInt(event.target.value as string, 10);

        this.setState({ brokerId: selectedBrokerId, page: 0 }, async () => {
            const { page, rowsPerPage, statusId, searchQuery } = this.state;
            const brokerFilter = selectedBrokerId === -1 ? undefined : selectedBrokerId;

            this.setState({ loading: true });

            try {
                const response = await fetchJob(
                    page,
                    rowsPerPage,
                    brokerFilter,
                    Number(statusId),
                    searchQuery
                );

                if (response?.data?.length > 0) {
                    this.setState({
                        rows: response.data,
                        totalCount: response.totalCount,
                    });
                    this.showSnackbar('Jobs fetched successfully!', 'success');
                } else {
                    this.setState({ rows: [], totalCount: 0 });
                    this.showSnackbar('No data found for the selected broker.', 'info');
                }
            } catch (error) {
                console.error('Error fetching broker jobs:', error);
                this.showSnackbar('Failed to fetch jobs.', 'error');
            } finally {
                this.setState({ loading: false });
            }
        });
    };


    render() {
        const { rows, loading, order, orderBy, page, roleID, openConfirmDialog, rowsPerPage,
            snackbarOpen, snackbarMessage, snackbarSeverity, selectedStatusFilter, totalCount, decodedTokenJson } = this.state;
        const { displaysidebar, location } = this.props;
        const { brokerId, brokerList } = this.state;

        const calculateTatDays = (start: string | number | Date, end?: string | number | Date) => {
            const startDate = new Date(start);
            const endDate = end ? new Date(end) : new Date();

            // Reset to midnight
            startDate.setHours(0, 0, 0, 0);
            endDate.setHours(0, 0, 0, 0);

            if (endDate <= startDate) return 0;

            // If created on weekend → freeze until next Monday
            const startDay = startDate.getDay(); // 0=Sun, 6=Sat
            let effectiveStart = new Date(startDate);
            if (startDay === 6) {
                // Saturday → push to Monday
                effectiveStart.setDate(effectiveStart.getDate() + 2);
            } else if (startDay === 0) {
                // Sunday → push to Monday
                effectiveStart.setDate(effectiveStart.getDate() + 1);
            }

            // If end is still before effectiveStart → TAT = 0
            if (endDate <= effectiveStart) return 0;

            let tat = 0;
            let current = new Date(effectiveStart);

            // Start counting the day AFTER effectiveStart
            current.setDate(current.getDate() + 1);

            while (current <= endDate) {
                const day = current.getDay();
                if (day !== 0 && day !== 6) {
                    tat++;
                }
                current.setDate(current.getDate() + 1);
            }

            return tat;
        };


        const rowsWithSerialNumber = rows?.map((row, index) => {
            const createdDate = new Date(row.CreatedOn);
            const dispatchedOn = row.DispatchedOn ? new Date(row.DispatchedOn) : undefined;

            const tatDays = calculateTatDays(createdDate, dispatchedOn);

            return {
                ...row,
                sNo: page * rowsPerPage + index + 1,
                TAT: tatDays,
            };
        });

        const sortedRows = rowsWithSerialNumber?.filter((row: any) =>
            row?.JobId?.toLowerCase()?.includes(this.state?.searchQuery.toLowerCase()) &&
            (selectedStatusFilter === '' || row?.Status === selectedStatusFilter)
        );

        const headCells: HeadCell[] = [
            { id: 'JobId', label: 'Job Id', disableSort: true },
            { id: 'JobTypeId', label: 'JobType Id', disableSort: true },
            { id: 'IsAutoDispatchJob', label: 'IsAutoDispatchJob', disableSort: true },
            { id: 'Status', label: 'Status', disableSort: true },
            { id: 'ClientName', label: 'Client Name', disableSort: true },
            { id: 'MacroFile', label: 'CheckList Type', disableSort: true },
            { id: 'CreatedOn', label: 'Uploaded On', disableSort: true },
            { id: 'UploadedBy', label: 'Uploaded By', disableSort: true },
            { id: 'TAT', label: 'TAT', disableSort: true },
            { id: 'Actions', label: 'Actions', disableSort: true },
            { id: 'UpdateStatus', label: 'Update Status', disableSort: true },
            { id: 'Dispatch', label: 'Dispatch', disableSort: true },
            { id: 'UploadDiscrepancy', label: 'Upload Discrepancy', disableSort: true },
            { id: 'Remarks', label: 'Remarks', disableSort: true }
        ];

        const visibleHeadCells = headCells?.filter(cell => {
            if (cell.id === 'Dispatch') {
                return [UserRole.Reviewer, UserRole.Supervisor, UserRole.QA]?.includes(Number(roleID));
            }
            if (cell.id === 'UpdateStatus') {
                return [UserRole.Supervisor]?.includes(Number(roleID));
            }
            if (cell.id === 'UploadedBy') {
                return [UserRole.Reviewer, UserRole.QA].includes(Number(roleID));
            }
            return true;
        });


        const visibleRows = orderBy
            ? sortedRows.slice().sort(getComparator<Row>(order, orderBy))
            : sortedRows;

        const showNoJobsMessage = selectedStatusFilter !== '' && visibleRows.length === 0;

        const columnWidths = {
            JobId: 210,
            JobTypeId: 100,
            IsAutoDispatchJob: 145,
            Status: 220,
            ClientName: 200,
            MacroFile: 200,
            CreatedOn: 130,
            UploadedBy: 225,
            TAT: 60,
            Actions: 190,
            UpdateStatus: 190,
            Dispatch: 130,
            UploadDiscrepancy: 150,
            Remarks: 200
        };

        return (
            <>
                {loading && (
                    <Box sx={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        backgroundColor: 'rgba(255, 255, 255, 0.5)',
                        zIndex: 9999
                    }}>
                        <div className="loader"></div> {/* Your loader component or custom CSS */}
                    </Box>
                )}

                <GridTable displaysidebar={displaysidebar}>
                    <div>
                        <Grid container justifyContent="space-between" alignItems="center" sx={{ mb: 2 }}>
                            {/* Left side: Broker and Status */}
                            <Grid item>
                                <Box display="flex" gap={2} alignItems="center">
                                    {/* Broker Name Dropdown */}
                                    <Box>
                                        <Typography
                                            variant="body2"
                                            sx={{ mb: 0.5, fontWeight: '500', }}
                                        >
                                            Select Broker
                                        </Typography>
                                        <Select
                                            value={this.state.brokerId}
                                            onChange={this.handleBrokerChange}
                                            size="small"
                                            sx={{ minWidth: 120, fontSize: '12px' }}
                                        >
                                            <MenuItem value={-1} sx={{ fontSize: '12px' }}>All</MenuItem>
                                            {this.state.brokerList.map((broker) => (
                                                <MenuItem
                                                    key={broker.Broker_ID}
                                                    value={broker.Broker_ID}
                                                    sx={{ fontSize: '12px' }}
                                                >
                                                    {broker.vchBrokerName}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </Box>

                                    {/* Status Dropdown */}
                                    <Box>
                                        <Typography variant="body2" sx={{ mb: 0.5, fontWeight: '500' }}>
                                            Select Status
                                        </Typography>
                                        <Select
                                            size="small"
                                            value={this.state.statusId}
                                            onChange={(event) => {
                                                const selectedStatusId = event.target.value;
                                                this.setState({ statusId: selectedStatusId, page: 0 }, this.fetchJobs);
                                            }}
                                            displayEmpty
                                            sx={{ minWidth: 120, fontSize: '12px' }}
                                        >
                                            <MenuItem value="0" sx={{ fontSize: '12px' }}>All</MenuItem>
                                            {this.state.jobInfoStatus.map((status) => (
                                                <MenuItem key={status.Id} value={status.Id.toString()} sx={{ fontSize: '12px' }}>
                                                    {status.Name}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </Box>

                                    <Box display="flex" alignItems="center" gap={0} sx={{ mt: 3 }}>
                                        {/* Search */}
                                        <TextField
                                            size="small"
                                            placeholder="Search by Job ID"
                                            value={this.state.searchTerm}
                                            onChange={this.handleSearchChange}
                                            onKeyDown={this.handleSearchKeyDown}
                                            sx={{
                                                '& .MuiInputBase-input::placeholder': { fontSize: '11px' },
                                                '& .MuiInputBase-input': { fontSize: '11px' },
                                                width: 180,
                                            }}
                                        />
                                        <Tooltip title="Click here for search result">
                                            <IconButton
                                                onClick={this.handleSearchClick}
                                                sx={{ mr: 1.5, height: '33px', border: '0.2px solid #d0bcbca1', borderRadius: '9%' }}
                                            >
                                                <Search fontSize="small" />
                                            </IconButton>
                                        </Tooltip>
                                    </Box>
                                </Box>
                            </Grid>

                            {/* Right side: Search + Refresh */}
                            <Grid item>
                                <Box display="flex" alignItems="center" gap={1}>
                                    {/* Refresh Icon */}
                                    <Box sx={{ marginTop: '26px' }}>
                                        <Tooltip title="Click here to refresh the table">
                                            <span>
                                                <Refresh
                                                    sx={{
                                                        cursor: 'pointer',
                                                        color: 'blue',
                                                        border: '0.1px solid black',
                                                        borderRadius: '4px',
                                                        padding: '3px',
                                                        height: 30,
                                                        width: 30,
                                                        mr: 1.5,
                                                        mt: 0.1,
                                                        boxShadow: 'rgba(17, 17, 26, 0.1) 0px 0px 8px',
                                                    }}
                                                    onClick={() => {
                                                        this.setState({
                                                            searchTerm: '',
                                                            searchQuery: '',
                                                            selectedStatusFilter: '',
                                                            statusId: '0',
                                                            brokerId: -1,
                                                            page: 0,
                                                        }, () => {
                                                            this.fetchJobs();
                                                        });
                                                    }}
                                                />
                                            </span>
                                        </Tooltip>
                                    </Box>
                                </Box>
                            </Grid>
                        </Grid>

                        <Paper sx={{ width: '100%', mb: 2, overflow: 'hidden', border: '0.5px solid #7a6e6e54' }}>
                            <Box sx={{ maxHeight: 400, overflowX: 'auto' }}>
                                <TableContainer sx={{ minWidth: 'max-content' }}>
                                    <Table stickyHeader sx={{ height: '50px' }} size="small">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell sx={{ fontSize: '11px', width: 60, fontWeight: 'bold' }}>S.No</TableCell>
                                                {visibleHeadCells?.map((headCell) => (
                                                    //   <TableCell
                                                    //     key={headCell.id}
                                                    //     sortDirection={
                                                    //         headCell.disableSort ? false : orderBy === headCell.id ? order : false
                                                    //     }
                                                    //     sx={{ fontSize: '11px', width: 190 }}
                                                    // >
                                                    //     {headCell.disableSort ? (
                                                    //         headCell.label
                                                    //     ) : (
                                                    //         <TableSortLabel
                                                    //             active={orderBy === headCell.id}
                                                    //             direction={orderBy === headCell.id ? order : 'asc'}
                                                    //             onClick={(event) => this.handleRequestSort(event, headCell.id)}
                                                    //         >
                                                    //             {headCell.label}
                                                    //         </TableSortLabel>
                                                    //     )}
                                                    <TableCell
                                                        key={headCell.id}
                                                        sx={{
                                                            fontSize: '12px',
                                                            fontWeight: 'bold',
                                                            textAlign: 'center',
                                                            width: columnWidths[headCell.id as keyof typeof columnWidths] || 190, // fallback width
                                                            minWidth: columnWidths[headCell.id as keyof typeof columnWidths] || 190
                                                        }}
                                                    >
                                                        {headCell.label}
                                                    </TableCell>
                                                ))}


                                                {/* <TableCell sx={{ fontSize: '11px', width: 130 }}>Status</TableCell>
                                                <TableCell sx={{ fontSize: '11px', width: 130 }}>Actions</TableCell>
                                                <TableCell sx={{ fontSize: '11px', width: 130 }}>Dispatch</TableCell>
                                                <TableCell sx={{ fontSize: '11px', width: 130 }}>UploadDiscrepancy</TableCell> */}
                                            </TableRow>
                                        </TableHead>

                                    </Table>

                                    <Box sx={{ maxHeight: 310, overflowY: 'auto', overflowX: 'auto', scrollbarWidth: 'none', '&::-webkit-scrollbar': { display: 'none', }, }}>
                                        <Table size="small">
                                            <TableBody>
                                                {showNoJobsMessage ? (
                                                    <TableRow>
                                                        <TableCell colSpan={headCells.length + 3} align="center"
                                                            sx={{
                                                                fontSize: '14px',
                                                                fontWeight: 500,
                                                                color: 'gray',
                                                                padding: '20px',
                                                                borderBottom: 'none',
                                                            }}>
                                                            No JobIds found for the selected status.
                                                        </TableCell>
                                                    </TableRow>
                                                ) :
                                                    visibleRows?.length === 0 ? (
                                                        <TableRow>
                                                            <TableCell colSpan={headCells.length + 3} align="center"
                                                                sx={{
                                                                    fontSize: '14px',
                                                                    fontWeight: 500,
                                                                    color: 'gray',
                                                                    padding: '20px',
                                                                    borderBottom: 'none',
                                                                }}>
                                                                No records to display
                                                            </TableCell>
                                                        </TableRow>
                                                    ) : (
                                                        visibleRows?.map((row, index) => {
                                                            const statusKey: any = row.Status;
                                                            const { bg, text } = getStatusColor(Number(statusKey));
                                                            const formatedDate = new Intl.DateTimeFormat('en-GB').format(new Date(row.CreatedOn));
                                                            const formattedDispatchedOn = row.DispatchedOn ? new Intl.DateTimeFormat('en-GB').format(new Date(row.DispatchedOn)) : '';
                                                            return (
                                                                <TableRow hover key={row.Id}>
                                                                    <TableCell sx={{ fontSize: '11px', width: 60 }}>
                                                                        {page * rowsPerPage + index + 1}
                                                                    </TableCell>

                                                                    <TableCell
                                                                        sx={{
                                                                            fontSize: '11px',
                                                                            width: columnWidths.JobId,
                                                                            whiteSpace: 'nowrap',
                                                                            overflow: 'hidden',
                                                                            textOverflow: 'ellipsis',
                                                                            textAlign: "center"
                                                                        }}
                                                                    >
                                                                        {[
                                                                            JobInfoStatusEnum.GridDataIntegrationCompleted, JobInfoStatusEnum.ChecklistGenerationInProgress,
                                                                            JobInfoStatusEnum.ChecklistGenerationCompleted, JobInfoStatusEnum.ChecklistGenerationFailed,
                                                                            JobInfoStatusEnum.Success, JobInfoStatusEnum.ReadyToDispatchFailed
                                                                        ]?.includes(Number(row?.Status)) &&
                                                                            [UserRole.Reviewer, UserRole.Supervisor, UserRole.QA]?.includes(Number(roleID)) ? (
                                                                            <Link
                                                                                href={`${GridUrl}=${row.JobId}&token=${btoa(row.JobId)}` + (decodedTokenJson?.Email ? `&userId=${btoa(decodedTokenJson?.Email)}` : '')}
                                                                                target="_blank"
                                                                                rel="noopener noreferrer"
                                                                                color="primary"
                                                                            >
                                                                                {row.JobId}
                                                                            </Link>
                                                                        ) : (row.JobId)}
                                                                    </TableCell>

                                                                    <TableCell sx={{ fontSize: '11px', width: columnWidths.JobTypeId, textAlign: "center" }}>
                                                                        {(() => {
                                                                            const jobTypeMapping: Record<number, string> = {
                                                                                1: "AR",
                                                                                2: "MR",
                                                                            };
                                                                            return jobTypeMapping[row.JobTypeId] || "Unknown";
                                                                        })()}
                                                                    </TableCell>

                                                                    <TableCell sx={{ fontSize: '11px', width: columnWidths.IsAutoDispatchJob, textAlign: "center" }}>
                                                                        {row?.IsAutoDispatchJob ?
                                                                            <Chip
                                                                                label={row?.StpMatched ? "Green" : "Red"}
                                                                                size="small"
                                                                                color={row?.StpMatched ? "success" : "error"}
                                                                                sx={{
                                                                                    fontWeight: 500,
                                                                                    fontSize: '11px',
                                                                                    height: '22px',
                                                                                    borderRadius: '20px',
                                                                                    px: 0,
                                                                                }}
                                                                            />
                                                                            :
                                                                            "false"}
                                                                    </TableCell>

                                                                    <TableCell sx={{ width: columnWidths.Status, textAlign: "center" }}>
                                                                        <Chip
                                                                            label={newstatusValueArray[statusKey]}
                                                                            size="small"
                                                                            sx={{
                                                                                backgroundColor: bg,
                                                                                color: text,
                                                                                fontWeight: 500,
                                                                                fontSize: '11px',
                                                                                height: '22px',
                                                                                borderRadius: '20px',
                                                                                px: 0,
                                                                            }}
                                                                        />
                                                                    </TableCell>

                                                                    <TableCell sx={{
                                                                        fontSize: '11px', width: columnWidths.ClientName, textAlign: "center", whiteSpace: 'normal',
                                                                        wordBreak: 'break-word',
                                                                        overflowWrap: 'anywhere',
                                                                        lineHeight: 1.5
                                                                    }}>
                                                                        {row.ClientName}
                                                                    </TableCell>

                                                                    <TableCell sx={{
                                                                        fontSize: '11px', width: columnWidths.MacroFile, textAlign: "center", whiteSpace: 'normal',
                                                                        wordBreak: 'break-word',
                                                                        overflowWrap: 'anywhere',
                                                                        lineHeight: 1.5
                                                                    }}>
                                                                        {row.MacroFile}
                                                                    </TableCell>

                                                                    <TableCell sx={{ fontSize: '11px', width: columnWidths.CreatedOn, textAlign: "center" }}>
                                                                        {formatedDate}
                                                                    </TableCell>

                                                                    {[UserRole.Reviewer, UserRole.QA].includes(Number(roleID)) && (
                                                                        <TableCell sx={{ fontSize: '11px', width: columnWidths.UploadedBy, textAlign: "center", whiteSpace: "normal", wordBreak: "break-word", overflowWrap: "break-word", }}>
                                                                            {row.UploadedBy}
                                                                        </TableCell>
                                                                    )}
                                                                    <TableCell sx={{ fontSize: '11px', width: columnWidths.TAT, textAlign: "center" }}>
                                                                        {row.TAT}
                                                                    </TableCell>

                                                                    <TableCell sx={{ width: columnWidths.Actions, textAlign: "center" }}>
                                                                        <Box
                                                                            sx={{
                                                                                display: 'flex',
                                                                                justifyContent: 'center',
                                                                                alignItems: 'center',
                                                                                gap: 0.5,
                                                                            }}
                                                                        >
                                                                            <IconButton onClick={this.handleViewClick(row.Id, row.JobId)} size="small">
                                                                                <Visibility fontSize="small" />
                                                                            </IconButton>

                                                                            <IconButton onClick={this.handleFileInfoClick(row.Id, row.JobId)} size="small">
                                                                                <SimCardDownload fontSize="small" />
                                                                            </IconButton>

                                                                            {roleID === UserRole?.Supervisor && (
                                                                                <IconButton onClick={() => this.openDeleteDialog(row.JobId)} size="small">
                                                                                    <Delete fontSize="small" />
                                                                                </IconButton>
                                                                            )}

                                                                            {[UserRole.QA, UserRole.Reviewer]?.includes(roleID) && (
                                                                                <Tooltip title="ReProcess">
                                                                                    <IconButton onClick={() => this.openReprocessDialog(row.JobId, row?.Id)} size="small">
                                                                                        <Replay fontSize="small" />
                                                                                    </IconButton>
                                                                                </Tooltip>
                                                                            )}
                                                                        </Box>
                                                                    </TableCell>

                                                                    {roleID === UserRole?.Supervisor && (
                                                                        <TableCell sx={{ width: columnWidths.UpdateStatus, textAlign: "center" }}>
                                                                            <Tooltip title="Click here to Update JobId Status">
                                                                                <Button
                                                                                    variant="contained"
                                                                                    component="label"
                                                                                    size="small"
                                                                                    onClick={() => this.openUpdateStatusDialog(row.JobId)}
                                                                                    sx={{
                                                                                        minWidth: '20px',
                                                                                        height: '18px',
                                                                                        fontSize: '7px',
                                                                                        color: 'black',
                                                                                        fontWeight: 600,
                                                                                        padding: '4px 4px',
                                                                                        backgroundColor: 'beige'
                                                                                    }}
                                                                                >
                                                                                    Update Status
                                                                                </Button>
                                                                            </Tooltip>
                                                                        </TableCell>
                                                                    )}

                                                                    {[UserRole.Reviewer, UserRole.Supervisor, UserRole.QA].includes(Number(roleID)) && (
                                                                        <TableCell sx={{ width: columnWidths.Dispatch, textAlign: "center" }}>
                                                                            {(row?.Status === 22 && row?.Checklist != null) && (
                                                                                <Tooltip title="Click here to dispatch JobId">
                                                                                    <span>
                                                                                        <IconButton
                                                                                            onClick={() => this.handleOpenConfirmDialog(row?.Id, row?.JobId)}
                                                                                            size="small"
                                                                                            disabled={[25, 26, 27].includes(Number(row?.Status))}
                                                                                        >
                                                                                            <ForwardToInbox
                                                                                                sx={{
                                                                                                    cursor: 'pointer',
                                                                                                    boxShadow:
                                                                                                        'rgba(67, 71, 85, 0.27) 0px 0px 0.25em, rgba(90, 125, 188, 0.05) 0px 0.25em 1em',
                                                                                                }}
                                                                                                fontSize="small"
                                                                                            />
                                                                                        </IconButton>
                                                                                    </span>
                                                                                </Tooltip>
                                                                            )}
                                                                        </TableCell>
                                                                    )}

                                                                    <TableCell sx={{ width: columnWidths.UploadDiscrepancy, textAlign: "center" }}>

                                                                        <Button
                                                                            variant="contained"
                                                                            component="label"
                                                                            size="small"
                                                                            sx={{
                                                                                minWidth: '20px',
                                                                                height: '20px',
                                                                                fontSize: '7px',
                                                                                color: 'black',
                                                                                fontWeight: 300,
                                                                                border: '1px solid black',
                                                                                backgroundColor: 'lightgray'
                                                                            }}
                                                                        >
                                                                            Choose File
                                                                            <input
                                                                                type="file"
                                                                                hidden
                                                                                onChange={(e) => this.handleFileChange(e, row.JobId)}
                                                                            />
                                                                        </Button>
                                                                    </TableCell>

                                                                    <TableCell sx={{
                                                                        fontSize: '11px',
                                                                        width: columnWidths.Remarks,
                                                                        maxWidth: columnWidths.Remarks,
                                                                        whiteSpace: 'normal',
                                                                        wordBreak: 'break-word',
                                                                        overflowWrap: 'break-word',
                                                                        textAlign: "center",
                                                                    }}>
                                                                        {row.Remarks}
                                                                    </TableCell>
                                                                </TableRow>
                                                            );
                                                        })
                                                    )}
                                            </TableBody>
                                        </Table>
                                    </Box>
                                </TableContainer>
                            </Box>

                            <TablePagination
                                rowsPerPageOptions={[5, 10, 20, 50, 100]}
                                component="div"
                                count={totalCount}
                                rowsPerPage={rowsPerPage}
                                page={page}
                                onPageChange={this.handleChangePage}
                                onRowsPerPageChange={this.handleChangeRowsPerPage}
                            />
                        </Paper>

                        {/* Confirmation Dialog For Delete*/}
                        <Dialog open={this.state.isDeleteDialogOpen} onClose={this.handleDeleteDialogClose}>
                            <DialogContent sx={{
                                padding: '0px 40px',
                                paddingTop: '15px',
                                paddingBottom: '30px',
                                textAlign: 'center',
                            }}>
                                <Box
                                    sx={{
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        mb: 2,
                                    }}
                                >
                                    <Box
                                        sx={{
                                            backgroundColor: '#FEE2E2',
                                            borderRadius: '50%',
                                            width: 60,
                                            height: 60,
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                        }}
                                    >
                                        <Delete sx={{ color: '#B91C1C', fontSize: 30 }} />
                                    </Box>
                                </Box>
                                <DialogTitle sx={{ textAlign: 'center', fontWeight: 'bold', fontSize: '1.25rem', p: 0 }}>Confirm Delete Job!</DialogTitle>
                                <DialogContentText sx={{ textAlign: 'center', mt: 1, mb: 3, color: 'rgba(0, 0, 0, 0.7)' }}>
                                    Are you sure you want to delete this <br /> job:{" "}
                                    <strong>{this.state.SelectedJob}</strong>?
                                </DialogContentText>
                                <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2, height: '30px' }}>
                                    <Button
                                        onClick={this.handleDeleteClick(this.state.SelectedJob)}
                                        color="primary"
                                        variant="contained"
                                        autoFocus
                                    >
                                        Yes
                                    </Button>
                                    <Button onClick={this.handleDeleteDialogClose}
                                        sx={{
                                            color: '#007bff',
                                            borderColor: '#007bff',
                                            border: '0.5px solid #53494987',
                                            // px: 4,
                                            // borderRadius: '6px',
                                            '&:hover': {
                                                borderColor: '#0056b3',
                                                color: '#0056b3',
                                            },
                                        }}>
                                        No
                                    </Button>
                                </Box>
                            </DialogContent>
                        </Dialog>

                        {/* Confirmation Dialog For ReProcess*/}
                        <Dialog open={this.state.isReProcessDialogOpen} onClose={this.handleReProcessDialogClose}>
                            <DialogContent
                                sx={{
                                    padding: '0px 40px',
                                    paddingTop: '15px',
                                    paddingBottom: '30px',
                                    textAlign: 'center',
                                }}
                            >
                                <DialogTitle sx={{ fontWeight: 'bold', fontSize: '1.25rem', p: 0 }}>
                                    Confirm ReProcess Job!
                                </DialogTitle>

                                <DialogContentText
                                    sx={{
                                        textAlign: 'center',
                                        mt: 1,
                                        mb: 2,
                                        color: 'rgba(0, 0, 0, 0.7)',
                                    }}
                                >
                                    Are you sure you want to ReProcess <br />
                                    job: <strong>{this.state.SelectedJob}</strong>
                                </DialogContentText>

                                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', mb: 3 }}>
                                    <Typography sx={{ mb: 1 }}>Select Broker <span style={{ color: 'red' }}>*</span></Typography>
                                    <Select
                                        value={this.state.reprocessBrokerId}
                                        onChange={(e) => { this.setState({ reprocessBrokerId: e.target.value }) }}
                                        size="small"
                                        sx={{ minWidth: 160, fontSize: '13px' }}
                                        displayEmpty={false}
                                    >
                                        {this.state.brokerList?.filter((f) => f.Broker_ID > 0)?.map((broker) => (
                                            <MenuItem key={broker.Broker_ID} value={broker.Broker_ID}>
                                                {broker.vchBrokerName}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </Box>

                                <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2, height: '30px' }}>
                                    <Button
                                        onClick={this.handleReprocessClick(this.state.SelectedJob, this.state.selectedJobId)}
                                        color="primary"
                                        variant="contained"
                                        disabled={!(this.state.reprocessBrokerId && this.state.reprocessBrokerId > 0)} // Disables until a broker is selected
                                    >
                                        Yes
                                    </Button>

                                    <Button
                                        onClick={this.handleReProcessDialogClose}
                                        sx={{
                                            color: '#007bff',
                                            borderColor: '#007bff',
                                            border: '0.5px solid #53494987',
                                            '&:hover': {
                                                borderColor: '#0056b3',
                                                color: '#0056b3',
                                            },
                                        }}
                                    >
                                        No
                                    </Button>
                                </Box>
                            </DialogContent>
                        </Dialog>


                        {/* Confirmation Dialog For Update JobId Status*/}
                        <Dialog open={this.state.isUpdateDialogOpen} onClose={this.handleUpdateStatusDialogClose}>
                            <DialogContent sx={{
                                padding: '0px 20px',
                                paddingTop: '20px',
                                paddingBottom: '22px',
                                textAlign: 'center',
                                width: '450px'
                            }}>
                                <Box
                                    sx={{
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        mb: 2,
                                    }}
                                >
                                    <Box
                                        sx={{
                                            backgroundColor: '#c9e8ed85',
                                            borderRadius: '50%',
                                            width: 60,
                                            height: 60,
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                        }}
                                    >
                                        <SyncAlt sx={{ color: '#37c1dd', fontSize: 30 }} />
                                    </Box>
                                </Box>
                                <DialogTitle sx={{ textAlign: 'center', fontWeight: 'bold', fontSize: '1.25rem', p: 0 }}>Confirm Status Update for Job!</DialogTitle>
                                <DialogContentText sx={{ textAlign: 'center', mt: 1, mb: 3, color: 'rgba(0, 0, 0, 0.7)' }}>
                                    Are you sure you want to Update the status as Dispatch Failed for this <br /> job:{" "}
                                    <strong>{this.state.SelectedJob}</strong>?
                                </DialogContentText>
                                <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2, height: '30px' }}>
                                    <Button
                                        onClick={this.handleJobStatusUpdate(this.state.SelectedJob)}
                                        color="primary"
                                        variant="contained"
                                        autoFocus
                                    >
                                        Yes
                                    </Button>
                                    <Button onClick={this.handleUpdateStatusDialogClose}
                                        sx={{
                                            color: '#007bff',
                                            borderColor: '#007bff',
                                            border: '0.5px solid #53494987',
                                            '&:hover': {
                                                borderColor: '#0056b3',
                                                color: '#0056b3',
                                            },
                                        }}>
                                        No
                                    </Button>
                                </Box>
                            </DialogContent>
                        </Dialog>

                        {/* Confirmation Dialog For Dispatch*/}
                        <Dialog open={openConfirmDialog} onClose={this.handleCloseConfirmDialog}>
                            <DialogContent sx={{
                                padding: '0px 30px',
                                paddingTop: '15px',
                                paddingBottom: '20px',
                                textAlign: 'center',
                            }}>
                                <Box
                                    sx={{
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        mb: 2,
                                    }}
                                >
                                    <Box
                                        sx={{
                                            backgroundColor: '#E5E7EB',
                                            borderRadius: '50%',
                                            width: 60,
                                            height: 60,
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                        }}
                                    >
                                        <ForwardToInbox sx={{ color: '#111827', fontSize: 30 }} />
                                    </Box>
                                </Box>
                                <DialogTitle sx={{ textAlign: 'center', fontWeight: 'bold', fontSize: '1.25rem', p: 0 }}>
                                    Dispatch!
                                </DialogTitle>
                                <DialogContentText sx={{ textAlign: 'center', mt: 1, mb: 3, color: 'rgba(0, 0, 0, 0.7)' }}>
                                    Are you sure want to dispatch this <br /> job:{" "}
                                    <strong>{this.state.SelectedJob}</strong>?
                                </DialogContentText>
                                <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2, height: '30px' }}>
                                    <Button
                                        variant="contained"
                                        sx={{
                                            px: 4,
                                            borderRadius: '6px',
                                        }}
                                        onClick={this.handleDispatchJobIdClick(this.state.dispatchId)}
                                    >
                                        Yes
                                    </Button>
                                    <Button
                                        // variant="outlined"
                                        onClick={this.handleCloseConfirmDialog}
                                        sx={{
                                            color: '#007bff',
                                            borderColor: '#007bff',
                                            border: '0.5px solid #53494987',
                                            px: 4,
                                            borderRadius: '6px',
                                            '&:hover': {
                                                borderColor: '#0056b3',
                                                color: '#0056b3',
                                            },
                                        }}
                                    >
                                        No
                                    </Button>
                                </Box>
                            </DialogContent>
                        </Dialog>

                    </div>
                    {this.renderActivityModel()}
                    {this.renderFileInfoDrawer()}
                </GridTable >
                <Snackbar
                    open={snackbarOpen}
                    autoHideDuration={2500}
                    onClose={() => this.setState({ snackbarOpen: false })}
                    anchorOrigin={{ vertical: "top", horizontal: "right" }}
                >
                    <Alert onClose={() => this.setState({ snackbarOpen: false })} severity={snackbarSeverity} sx={{ width: "100%" }}>
                        {snackbarMessage}
                    </Alert>
                </Snackbar>
            </>
        );
    }
}

export default JobListing;
